module.exports = __webpack_public_path__ + "img/activity5.7b9bfbbc.png";